export default {
  event: {
    required: true,
    type: Object
  }
}
